import { useContext } from 'react'
import { OrderContext } from '../context/orderContext'

export const useOrderContext = () => useContext(OrderContext)
export default useOrderContext